import * as Diagram from "../../../../components/diagram";

export const CaseVisitDetail = {
  label: "個案訪視明細",
  key: "CaseVisitDetail",
  path: "AtriumFibrillation/CaseVisitDetail",
  api: "TCS_V_HeartCaseVisit",
  render: (options) => (
    <Diagram.AtriumFibrillation.CaseVisitDetail {...options} />
  ),
  isRaw: true,
  isPage: true,
  filterColumns: [
    { key: "篩檢日期", type: "date" },
    { key: "建案日期", type: "date" },
    { key: "案件狀態", type: "string" },
  ],
  columns: [
    {
      key: "編號",
      field: "編號",
      header: "編號",
    },
    {
      key: "居住鄉鎮",
      field: "居住鄉鎮",
      header: "居住鄉鎮",
    },
    {
      key: "篩檢日期",
      field: "篩檢日期",
      header: "篩檢日期",
    },
    {
      key: "姓名",
      field: "姓名",
      header: "姓名",
    },
    {
      key: "性別",
      field: "性別",
      header: "性別",
    },
    {
      key: "年齡",
      field: "年齡",
      header: "年齡",
    },
    {
      key: "地址",
      field: "地址",
      header: "地址",
    },
    {
      key: "電話",
      field: "電話",
      header: "電話",
    },
    {
      key: "手機",
      field: "手機",
      header: "手機",
    },
    {
      key: "是",
      field: "是",
      header: "是",
    },
    {
      key: "否",
      field: "否",
      header: "否",
    },
    {
      key: "回診日期",
      field: "回診日期",
      header: "回診日期",
    },
    {
      key: "抗凝血劑(回)",
      field: "抗凝血劑(回)",
      header: "抗凝血劑(回)",
    },
    {
      key: "不清楚(回)",
      field: "不清楚(回)",
      header: "不清楚(回)",
    },
    {
      key: "無(回",
      field: "無(回",
      header: "無(回)",
    },

    {
      key: "心律不整",
      field: "心律不整",
      header: "心律不整",
    },
    {
      key: "心房顫動",
      field: "心房顫動",
      header: "心房顫動",
    },
    {
      key: "心臟衰竭",
      field: "心臟衰竭",
      header: "心臟衰竭",
    },
    {
      key: "心肌梗塞",
      field: "心肌梗塞",
      header: "心肌梗塞",
    },
    {
      key: "心臟支架",
      field: "心臟支架",
      header: "心臟支架",
    },
    {
      key: "糖尿病",
      field: "糖尿病",
      header: "糖尿病",
    },
    {
      key: "腦中風",
      field: "腦中風",
      header: "腦中風",
    },
    {
      key: "高血壓",
      field: "高血壓",
      header: "高血壓",
    },
    {
      key: "抗凝血劑",
      field: "抗凝血劑",
      header: "抗凝血劑",
    },
    {
      key: "不清楚",
      field: "不清楚",
      header: "不清楚",
    },
    {
      key: "無",
      field: "無",
      header: "無",
    },
    {
      key: "案件狀態",
      field: "案件狀態",
      header: "案件狀態",
    },
  ],
};
